<template>
  <v-chart :options="chartOptions" autoresize class="day-of-week-chart" />
</template>

<script>
import ECharts from "vue-echarts";
import "echarts/lib/chart/bar";
import "echarts/lib/component/tooltip";
import "echarts/lib/component/title";
import "echarts/lib/component/legend";

export default {
  components: {
    "v-chart": ECharts,
  },
  props: {
    title: {
      type: String,
      default: "Weekday Activity",
    },
    chartData: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    chartOptions() {
      const daysOfWeek = [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ];
      let counts = Array(7).fill(0);

      // Process data to count entries per day of the week
      this.chartData.forEach((item) => {
        const date = new Date(parseInt(item.dateTime));
        const dayIndex = (date.getDay() + 6) % 7; // getDay() returns 0 for Sunday
        counts[dayIndex]++;
      });

      return {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          data: ["Visits"],
        },
        xAxis: {
          type: "category",
          name: "Day", // Label for the x-axis
          data: daysOfWeek.map((day) => day.substring(0, 3)), // Shorten day names to first 3 letters
          axisLabel: {
            interval: 0, // Show all labels without skipping
          },
        },
        grid: {
          left: "20px", // Adjusted left padding
          right: "7%", // Adjusted right padding
          bottom: "3%", // Adjusted bottom padding
          containLabel: true, // Ensure labels are contained within the grid
        },
        yAxis: {
          type: "value",
          name: "Count", // Label for the y-axis
          minInterval: 1, // Ensure y-axis values are integers
          axisLabel: {
            formatter: "{value}", // Display integers on y-axis
          },
        },
        series: [
          {
            name: "Visits",
            type: "bar",
            data: counts,
            itemStyle: {
              color: "#4186f4",
            },
          },
        ],
        label: {
          show: true,
          position: "top",
          color: "#000",
        },
      };
    },
  },
};
</script>

<style scoped>
.day-of-week-chart {
  width: 100%;
  height: 400px;
}
</style>
